module.exports = __webpack_public_path__ + "img/home_icon_251286-1.6d704421.png";